import { Inbox } from "lucide-react";

/**
 * EmptyState — whenever a data list / table / card rail has no entries.
 * Tone neutral + gold accent icon.
 */
export default function EmptyState({
  icon: Icon = Inbox,
  title = "Nothing here yet",
  description,
  action,
  className = "",
  ...rest
}) {
  return (
    <div
      className={`relative rounded-xl border-2 border-dashed border-slate-200 bg-white px-6 py-12 text-center ${className}`}
      data-testid={rest["data-testid"] || "empty-state"}
    >
      <div className="mx-auto h-12 w-12 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/30 flex items-center justify-center">
        <Icon className="h-5 w-5 text-[#D4AF37]" />
      </div>
      <h4 className="mt-5 text-base font-semibold text-[#0A192F] tracking-tight">{title}</h4>
      {description && (
        <p className="mt-2 text-sm text-slate-500 max-w-sm mx-auto leading-relaxed">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
